import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "DifficultySettingViewContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DifficultySettings = _resolveComponent("DifficultySettings");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.activeName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.activeName = $event),
    class: "demo-tabs"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "自由练习难度设置",
      name: "practice"
    }, {
      default: _withCtx(() => [$data.practice ? (_openBlock(), _createBlock(_component_DifficultySettings, {
        key: 0,
        data: $data.practice,
        type: "PRACTICE"
      }, null, 8, ["data"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "课上难度设置",
      name: "onclass"
    }, {
      default: _withCtx(() => [$data.onclass ? (_openBlock(), _createBlock(_component_DifficultySettings, {
        key: 0,
        data: $data.onclass,
        type: "ON_CLASS"
      }, null, 8, ["data"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]);
}